import * as React from 'react';

const IconTrophy = (props) => (
    <svg
        {...props}
        fill='none'
        height={32}
        viewBox='0 0 32 32'
        width={48}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M4.99996 1.25C4.99996 0.559644 5.5596 0 6.24996 0H25.75C26.4403 0 27 0.559644 27 1.25V3H29.4167C30.8434 3 32 4.1566 32 5.58333V10.4167C32 14.0525 29.0525 17 25.4167 17H24.5842C23.1259 19.2075 21.0664 21.0209 18.5699 22.1827L17.25 22.797V25.125L23.4167 29.75C23.8471 30.0728 24.0227 30.6349 23.8526 31.1453C23.6824 31.6557 23.2047 32 22.6667 32H9.33337C8.79534 32 8.31766 31.6557 8.14752 31.1453C7.97738 30.6349 8.15294 30.0728 8.58337 29.75L14.75 25.125V22.797L13.4301 22.1827C10.9336 21.0209 8.87411 19.2075 7.41574 17H6.58333C2.94746 17 0 14.0525 0 10.4167V5.58333C0 4.1566 1.1566 3 2.58333 3H4.99996V1.25ZM25.9201 14.4693C27.9377 14.2212 29.5 12.5014 29.5 10.4167V5.58333C29.5 5.53731 29.4627 5.5 29.4167 5.5H27V8.96113C27 10.8857 26.6213 12.7511 25.9201 14.4693ZM4.99996 8.96107V5.5H2.58333C2.53731 5.5 2.5 5.53731 2.5 5.58333V10.4167C2.5 12.5014 4.06224 14.2212 6.07986 14.4693C5.37861 12.751 4.99996 10.8857 4.99996 8.96107ZM7.49996 2.5V8.96107C7.49996 13.6603 10.2244 17.9334 14.4849 19.9161L15.9649 20.6049C15.9872 20.6153 16.0129 20.6153 16.0352 20.6049L17.5151 19.9162C21.7755 17.9334 24.5 13.6604 24.5 8.96113V2.5H7.49996ZM18.9167 29.5L16 27.3125L13.0834 29.5H18.9167Z'
            fill='currentColor'/>
    </svg>
);

export default IconTrophy;
